import { useLocale } from '@adsk/alloy-react-locale';

/**
 *  Hook to get the contextualized locale for the schedule activity plugin.
 */
export const useScheduleActivityLocale = () =>
  useLocale(({ locale }) => require(`../i18n/${locale}.json`));
